export default __webpack_public_path__ + "static/media/Better_World_full_mix.523d2522.mp3";